import React from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Spinner,
    FormGroup, // Added for checkbox
    Label, // Added for checkbox
} from "reactstrap";
import { RSelect } from "../../../components/Component"; // Adjust path as needed

const EditChannelPartnerModal = ({
    isOpen,
    toggle,
    editingPartner,
    formData, // Renamed from newPartnerData for clarity in this component
    handleInputChange, // Renamed from handleNewPartnerDataChange
    handleTypeChange, // Renamed from handleNewPartnerTypeChange
    typeOptions,
    handleEditPartnerSubmit,
    isLoading,
}) => {
    if (!editingPartner) return null; // Don't render if no partner is being edited

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Edit Channel Partner: {editingPartner?.name}</ModalHeader>
            <ModalBody>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="editPartnerName">
                            Partner Name
                        </label>
                        <Input
                            type="text"
                            id="editPartnerName"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Enter partner name"
                        />
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editPartnerType">
                            Partner Type
                        </label>
                        <RSelect
                            options={typeOptions.filter((opt) => opt.value !== "")} // Exclude "All Types"
                            value={formData.type ? { label: formData.type, value: formData.type } : null}
                            onChange={(newValue) => {
                                if (newValue && newValue.__isNew__) {
                                    // Handle new value creation
                                    handleTypeChange({ value: newValue.value, label: newValue.value });
                                } else {
                                    handleTypeChange(newValue);
                                }
                            }}
                            placeholder="Select or Create Type"
                            id="editPartnerType"
                            isCreatable={true}
                            formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                        />
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editManagerName">
                            Manager Name
                        </label>
                        <Input
                            type="text"
                            id="editManagerName"
                            name="managerName"
                            value={formData.managerName}
                            onChange={handleInputChange}
                            placeholder="Enter manager name (optional)"
                        />
                    </div>

                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editPartnerWebsite">
                            Website
                        </label>
                        <Input
                            type="url"
                            id="editPartnerWebsite"
                            name="website"
                            value={formData.website}
                            onChange={handleInputChange}
                            placeholder="https://example.com"
                        />
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editManagerContact">
                            Manager Contact (Phone/Email)
                        </label>
                        <Input
                            type="text"
                            id="editManagerContact"
                            name="managerContact"
                            value={formData.managerContact}
                            onChange={handleInputChange}
                            placeholder="Enter manager contact details"
                        />
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editDocumentType">
                            Document Type
                        </label>
                        <Input
                            type="text"
                            id="editDocumentType"
                            name="documentType"
                            value={formData.documentType}
                            onChange={handleInputChange}
                            placeholder="e.g., Trade License, Agreement"
                        />
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label" htmlFor="editDocumentFile">
                            Document File
                        </label>
                        <Input
                            type="file"
                            id="editDocumentFile"
                            name="documentFile" // This name is handled by the parent's `handleNewPartnerDataChange` (passed as handleInputChange)
                            onChange={handleInputChange}
                        />
                        {/* Display existing document name if present and no new file is selected */}
                        {formData.document && !formData.documentFile && (
                            <small className="form-text text-muted">Current document: {formData.document.split('/').pop()}</small>
                        )}
                    </div>
                    <FormGroup switch className="mt-2">
                        <Input
                            type="switch"
                            id="editPartnerActiveStatus"
                            name="active"
                            checked={formData.active}
                            onChange={handleInputChange}
                        />
                        <Label htmlFor="editPartnerActiveStatus" check>
                            Active
                        </Label>
                    </FormGroup>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleEditPartnerSubmit} disabled={isLoading}>
                    {isLoading ? <Spinner size="sm" /> : "Update Partner"}
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditChannelPartnerModal;